import { CaretDownIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const ArrowDownSmall = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <CaretDownIcon size={Sizes[size]} {...rest} color={stroke || fill} />;
};

ArrowDownSmall.displayName = 'ArrowDownSmall';
